import { Button } from '@fluentui/react-components';
import { Add20Regular } from '@fluentui/react-icons';
import { GuideEmptyState } from '../../../theme/components/GuideEmptyState';
import { GuideTooltip } from '../../../theme/components/GuideTooltip';
import { ProviderPriceListFormComponent } from '../../../components/PriceList/ProviderPriceList/ProviderPriceListForm.Component';
import './ProviderPriceLists.Styles.css';
import { connect } from 'react-redux';
import { HeaderPersonaComponent } from '../../../commons/component/headers/HeaderPersona/HeaderPersonaComponent';
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import ProviderMedicalServiceAssociatedComponent from '../../../components/Providers/ProviderMedicalServiceAssociated/ProviderMedicalServiceAssociatedComponent';
import { PriceListHeaderComponent } from '../../../components/PriceList/PriceListHeader/PriceListHeaderComponent';
import PricesListComponent from '../../../components/PriceList/PricesList/PricesListComponent';
import { PriceListItemFormComponent } from '../../../components/PriceList/PricelistItemForm/PriceListItemForm.Component';
import { PriceDetails } from '../../../models/Entities/PriceList/PriceDetail';
import { ProviderPriceList } from '../../../models/Entities/ProviderAssociations/PriceLists/ProviderPriceList';
import { useBoolean } from '@fluentui/react-hooks';
import { ProviderPriceListInfoComponent } from '../../../components/PriceList/PriceListInfo/ProviderPriceListInfoComponent';
import { ProviderPriceListComponent } from '../../../components/PriceList/ProviderPriceList/ProviderPriceListComponent';
import { withRouter } from '../../../commons/component/withRouterCustom';
import { useEffect, useState } from 'react';
import ProviderConsumptionsSection from '../../../components/Providers/ProviderConsumptions/ProviderConsumptions.Section';
import ProviderContactSection from '../../../components/Providers/ProviderContact/ProviderContact.Section';
import { GuideTabs } from '../../../theme/components/GuideTabs';
import {
  ProviderDetailTabKey,
  buildProviderDetailSearch,
  resolveProviderDetailTab,
} from '../../../functions/ProviderConsumptions.Functions';

// Component Functions
import * as ownFunctions from './ProviderDetailsPageFunctions';

////i18Next
import { useTranslation } from 'react-i18next';
import CashflowGeneralComponent from '../../../components/CashFlow/General/Cashflow.General.Component';

export const ProviderDetailsPage = (props: ownFunctions.Props) => {
  
  const [searchTextCriteria, setSearchTextCriteria] = useState<string>();
  const [selectedPriceList, setSelectedPriceList] =
    useState<ProviderPriceList>();

  const [UpdateMassivePriceIsActive, setUpdateMassivePriceIsActive] =
    useState<boolean>(false);

  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [priceToEdit, setPriceToEdit] = useState<PriceDetails>();

  // Alta de lista: drawer con nombre y comentario (antes se creaba con un nombre fijo).
  const [listFormOpen, setListFormOpen] = useState<boolean>(false);
  const [listFormSubmitted, setListFormSubmitted] = useState<boolean>(false);

  //useTranslation()
  const [t] = useTranslation();

  // La solapa vive en la URL (?tab=...&origins=...). Spec 006: "Consumos importados" se integró en la grilla
  // unificada "Consumos"; el vínculo viejo ?tab=importedConsumptions (detalle del consumo de protocolo)
  // abre "Consumos" filtrado por origen 5 y la URL se reescribe a ?tab=consumptions&origins=5.
  const locationSearch: string = props.location?.search ?? '';
  const [route, setRoute] = useState(() => resolveProviderDetailTab(locationSearch));
  const selectedTab: ProviderDetailTabKey = route.tab;

  const writeSearch = (search: string) =>
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${search}`);

  useEffect(() => {
    const resolved = resolveProviderDetailTab(locationSearch);
    setRoute(resolved);
    if (resolved.redirected) writeSearch(buildProviderDetailSearch(locationSearch, resolved.tab, resolved.origins));
  }, [locationSearch]);

  const handleTabChange = (key: string) => {
    const next = resolveProviderDetailTab(`?tab=${encodeURIComponent(key)}`).tab;
    setRoute((current) => ({ ...current, tab: next, redirected: false }));
    writeSearch(buildProviderDetailSearch(window.location.search, next));
  };

  // Solapa "Consumos": la página crece hacia abajo lo que haga falta (scroll de `.content`, como el resto de la app);
  // lo que no puede pasar es que la grilla se salga por el borde derecho: `provider-details--contained` corta el ancho
  // en cada eslabón y la grilla scrollea horizontalmente dentro de su recuadro.
  const fillLayout = selectedTab === 'consumptions' && !!props.Provider;

  const handleOriginsChange = (origins: number[]) =>
    writeSearch(buildProviderDetailSearch(window.location.search, 'consumptions', origins));

  useEffect(() => {
    if (props.Provider?.id === undefined) {
      props.GetProviderById(props.ProviderId);
    }
  }, [props.Provider?.id, props.ProviderId]);

  useEffect(() => {
    if (props.Provider?.id !== undefined) {
      props.GetPriceListByProviderId(props.ProviderId);
    }
  }, [props.Provider?.id, props.ProviderId]);

  useEffect(() => {
    setSelectedPriceList(undefined);
  }, [props.PriceListDeleted]);

  useEffect(() => {
    if (listFormSubmitted && props.PriceListAdded) {
      setListFormOpen(false);
      setListFormSubmitted(false);
    }
  }, [listFormSubmitted, props.PriceListAdded]);

  
  // events
  const HandleEditPriceEvent = (price: PriceDetails) => {
    setPriceToEdit(price);
    openPanel();
  };

  const HandleSearchServiceCriteriaChange = (criteria: string | undefined) => {
    setSearchTextCriteria(criteria);
  };

  const SelectPriceListHandler = (priceList: ProviderPriceList) => {
    setSelectedPriceList(priceList);
  };

  const handleClosePanel = () => {
    setPriceToEdit(undefined);
    dismissPanel();
  };

  const handleAddPriceClick = () => {
    openPanel();
  };

  const handleDeletePriceList = (
    AgreementId: number,
    MedicalAgreementPriceListId: number
  ) => {
    props.DeletePriceListById(AgreementId, MedicalAgreementPriceListId);
  };

  const handleCancelDeletePriceList = () => {
    props.ResetPriceListDeleteState();
  };

  const handleClonePriceList = (ProviderPriceListId: number) => {
    props.CloneProviderPriceList(ProviderPriceListId);
  };

  const handleCreateList = (listName: string, comments: string) => {
    if (!props.Provider) return;
    setListFormSubmitted(true);
    props.AddPriceList(props.Provider.id, listName, comments);
  };

  // El encabezado avisa con el id de la asociación; el borrado por lista espera el id de la lista.
  const handleDeleteSelectedPriceList = (providerPriceListId: number) => {
    const association = (props.Provider?.PriceListAssociated || []).find((item: ProviderPriceList) => item.id === providerPriceListId);
    if (association) handleDeletePriceList(props.Provider.id, association.priceListId);
  };

  return (
    <>
      <PageHeader title={t('providerDetailsPage.providerDetailsTitle')}/>
      <div className={fillLayout ? 'Content provider-details--contained' : 'Content'} data-testid="provider-details-content">
        <div className="Section">
          {props.Provider && (
            <HeaderPersonaComponent
              PersonaName={props.Provider.person?.businessName}
              secondaryText={t('providerDetailsPage.providerDetailsSubTitle')}
            />
          )}
        </div>
        <div className={fillLayout ? 'Section provider-details__tabs' : 'Section'}>
          {props.Provider && (
            <GuideTabs
              ariaLabel={t('providerDetailsPage.providerDetailsTitle')}
              data-testid="provider-details-tabs"
              selectedKey={selectedTab}
              onTabChange={handleTabChange}
              tabs={[
                {
                  key: 'consumptions',
                  label: t('providerConsumptionImport.tabs.consumptions'),
                  content: (
                    <ProviderConsumptionsSection
                      key={`${route.origins.join(',')}|${route.providerFileId ?? ''}|${route.importFileId ?? ''}`}
                      providerId={props.Provider.id}
                      providerName={props.Provider.person?.businessName ?? ''}
                      providerIdentifier={props.Provider.person?.personIdentifier || undefined}
                      initialOrigins={route.origins}
                      onOriginsChange={handleOriginsChange}
                      initialProviderFileId={route.providerFileId}
                      initialImportFileId={route.importFileId}
                      onImportFileConsumed={() => writeSearch(buildProviderDetailSearch(window.location.search, 'consumptions', route.origins))}
                    />
                  )
                },
                {
                  key: 'contact',
                  label: t('providerDetailsPage.providerDetailsItem.contact'),
                  content: <ProviderContactSection PersonId={props.Provider.person.id} PersonType={props.Provider.person.personType} />
                },
                {
                  key: 'financial',
                  label: t('providerDetailsPage.providerDetailsItem.financial'),
                  content: <CashflowGeneralComponent EntityIdentifier={props.OwnerId} FixedAssociatedEntityIdentifier={props.Provider.person.personIdentifier} />
                },
                {
                  key: 'medicalService',
                  label: t('providerDetailsPage.providerDetailsItem.medicalService'),
                  content: <ProviderMedicalServiceAssociatedComponent ProviderId={props.Provider.id} />
                },
                {
                  key: 'priceLists',
                  label: t('providerDetailsPage.providerDetailsItem.priceLists'),
                  content: (
                    <div className="ppx" data-testid="provider-price-lists">
                      <aside className="ppx__side">
                        <div className="ppx__side-head">
                          <h3 className="ppx__side-title">
                            {t('providerDetailsPage.priceLists.sidebarTitle')}
                            <span className="ppx__side-count">{(props.Provider.PriceListAssociated || []).length}</span>
                          </h3>
                          <GuideTooltip content={t('providerDetailsPage.priceLists.addList')} relationship="label">
                            <Button appearance="primary" size="small" icon={<Add20Regular />} onClick={() => setListFormOpen(true)} disabled={props.isAddingPriceList} data-testid="ppx-add-list" />
                          </GuideTooltip>
                        </div>
                        <ProviderPriceListComponent
                          priceList={props.Provider.PriceListAssociated || []}
                          selectedId={selectedPriceList?.id}
                          onSelectPriceList={SelectPriceListHandler}
                          loading={props.isLoadingProviderPriceList}
                          emptyAction={<Button appearance="primary" icon={<Add20Regular />} onClick={() => setListFormOpen(true)} disabled={props.isAddingPriceList} data-testid="ppx-add-list">{t('providerDetailsPage.priceLists.addList')}</Button>}
                        />
                      </aside>
                      <div className="ppx__main">
                        {selectedPriceList ? (
                          <>
                            <PriceListHeaderComponent
                              PriceList={selectedPriceList}
                              onAddMedicalService={handleAddPriceClick}
                              onSearchService={HandleSearchServiceCriteriaChange}
                              onDeletePriceList={handleDeleteSelectedPriceList}
                              onCancelDeletePriceList={handleCancelDeletePriceList}
                              onClonePriceList={handleClonePriceList}
                              onMassiveUpdateChange={(isActive: boolean) => setUpdateMassivePriceIsActive(isActive)}
                              isDeletingExecution={props.isDeletingPriceList}
                              FailOnDeleting={props.failOnDeletePriceList}
                              ErrorOnDeleting={props.DeletePriceListError}
                            />
                            <div className="ppx__detail">
                              <ProviderPriceListInfoComponent
                                ProviderPriceList={props.Provider.PriceListAssociated?.find((pricelist: ProviderPriceList) => pricelist.id === selectedPriceList.id) || selectedPriceList}
                              />
                              <PricesListComponent
                                PriceListId={selectedPriceList.priceList.id}
                                onEditPrice={HandleEditPriceEvent}
                                ServiceFilterCriteria={searchTextCriteria}
                                PriceMassiveEditionIsActive={UpdateMassivePriceIsActive}
                                showPrice={true}
                                showRemotePrice={false}
                                showFailPrice={false}
                                showPreScreaningPrice={false}
                                showRandomPrice={false}
                                showAdditionalPaymentPrice={false}
                              />
                            </div>
                          </>
                        ) : (
                          <div className="ppx__placeholder">
                            <GuideEmptyState title={t('providerDetailsPage.priceLists.selectTitle')} text={t('providerDetailsPage.priceLists.selectText')} data-testid="ppx-select-hint" />
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }
              ]}
            />
          )}
        </div>
      </div>
      {props.Provider && (
        <ProviderPriceListFormComponent
          open={listFormOpen}
          providerName={props.Provider.person?.businessName ?? ''}
          saving={!!props.isAddingPriceList}
          error={listFormSubmitted && props.failOnAddPriceList ? props.AddPriceListError : undefined}
          onDismiss={() => { setListFormOpen(false); setListFormSubmitted(false); }}
          onCreate={handleCreateList}
        />
      )}
      {selectedPriceList && (
        <PriceListItemFormComponent
          isOpen={isOpen}
          dismissPanel={handleClosePanel}
          openPanel={openPanel}
          PriceListId={selectedPriceList.priceList.id}
          PriceDetails={priceToEdit}
          showPrice={true}
          showPreScreeningPrice={false}
          showRemotePrice={false}
          showFailPrice={false}
          showRandomPrice={false}
          showAdditionalPaymentPrice={false}
        />
      )}
    </>
  );
};

export default withRouter(connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(ProviderDetailsPage as any));
